/**
 * @description: 服务评价报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="or-fp-report">
        <div class="fp-list">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="fpTime">
                        <input type="text" class="form-control laydate-icon" v-model="fpStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="fpEndTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="fp_shop" data-placeholder="请选择消费门店"></select>
                </div>
                <label class="list-label-2">区域:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择区域" ref="fp_area"></select>
                </div>
                <label class="list-label-3">包厢号:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择包厢号" ref="fp_box"></select>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-4">处理状态:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择处理状态" ref="fp_deal">
                        <option value=" ">全部</option>
                        <option value="1">已处理</option>
                        <option value="-1">未处理</option>
                    </select>
                </div>
                <label class="list-label-4">服务评价:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" data-placeholder="请选择服务评价" ref="fp_evalt">
                        <option value=" ">全部</option>
                        <option value="1">差评</option>
                        <option value="2">中评</option>
                        <option value="3">好评</option>
                    </select>
                </div>
                <div class="col-md-1 ct-col fp-tit-sel">
                    <select class="form-control" ref="fp_tit_sel">
                        <option value="ahead_user_name">用户微信昵称</option>
                        <option value="reply_user_name">操作员工姓名</option>
                        <option value="work_number">操作员工工号</option>
                    </select>
                </div>
                <div class="col-md-2 jh-con-val">
                    <input type="text" class="form-control" v-model="fp_con_val" :placeholder="fp_con_phd">
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="getFpList(1)" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getFpExportSet">导出</button>
                </div>
            </div>
            <div class="total-info">
                <div class="item" v-for="item in total_info" :key="item.name">
                    <span>{{item.name}}平均:</span>
                    <span>{{item.value}}星</span>
                </div>
            </div>
            
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                :data="list_table">
                <el-table-column :prop="item.key" 
                    :label="item.name" 
                    v-for="item in column_arr"
                    :key="item.key"
                >
                    <template slot-scope="scope">
                        <span v-if="item.key==='reply_user_name'" v-show="!!scope.row.reply_user_name">
                            {{scope.row.reply_user_name}}（{{scope.row.work_number}}）
                        </span>
                        <span v-else>{{scope.row[item.key]}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="page_size"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getFpList">
            </el-pagination>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="fpExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='fpExport_allcheck' @click='fpExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li v-for="item in column_arr" :key="item.key">
                            <input type="checkbox" v-model='fpExport_checkModel' :value="item.key">
                            <label>{{item.name}}</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='fpExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='fpExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                fpStartTime: "",
                fpEndTime: "",
                fp_field: "ahead_user_name",
                fp_con_phd: "请输入用户微信昵称",
                fp_con_val: "",
                total_info: [],
                loading: false,
                list_table: [],
                list_total: 0,
                list_page: 1,
                page_size: 10,
                column_arr: [],
                fpExport_allcheck: false,
                c_fpExport_allcheck: false,
                fpExport_checkModel: [],
                fpExport_checkData: [],
                fpExport_type: 1,
            }
        },
        watch: {
            fpExport_checkModel: {
                handler: function(val, oldVal) {
                    if(this.fpExport_checkModel.length >= this.fpExport_checkData.length) {
                        this.fpExport_allcheck = true;
                        this.c_fpExport_allcheck = true;
                    } else {
                        this.fpExport_allcheck = false;
                        this.c_fpExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            const _this = this
            // 日期
            _this.fpStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.fpEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.innitDate(); // 日期
            _this.shopDatas = [];
            _this.innitInput();  // 门店
            // 处理状态
            $(_this.$refs.fp_deal).select2({
                minimumResultsForSearch: -1,
                language: "zh-CN",
                width: '100%'
            });
            // 服务评价
            $(_this.$refs.fp_evalt).select2({
                minimumResultsForSearch: -1,
                language: "zh-CN",
                width: '100%'
            });
            // 下拉选项
            $(_this.$refs.fp_tit_sel).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1,
                width: '100%'
            }).change(function() {
                _this.fp_field = $(this).val();
                if(_this.fp_field == 'ahead_user_name') {
                    _this.fp_con_phd = '请输入用户微信昵称';
                } else if(_this.fp_field == 'reply_user_name') {
                    _this.fp_con_phd = '请输入操作员工姓名';
                } else if(_this.fp_field == 'work_number') {
                    _this.fp_con_phd = '请输入操作员工工号';
                }
            });
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.fpStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.fpEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.fpStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.fpEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.fpTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.fpStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.fpEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.fp_shop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                if(e.params.data.text == "全部") {
                                    // 区域
                                    $(_this.$refs.fp_area).val('').trigger('change');
                                    $(_this.$refs.fp_area).prop('disabled', true);
                                    // 包厢号
                                    $(_this.$refs.fp_box).val('').trigger('change');
                                    $(_this.$refs.fp_box).prop('disabled', true);
                                    $('.fp-avg').hide();
                                    return;
                                }
                                // 区域
                                $(_this.$refs.fp_area).val('').trigger('change');
                                $(_this.$refs.fp_area).prop('disabled', false);
                                _this.getRoomArea(e.params.data.id);
                                // 包厢号
                                $(_this.$refs.fp_box).val('').trigger('change');
                                $(_this.$refs.fp_box).prop('disabled', false);
                                _this.getRoomdata(e.params.data.id);
                                $('.fp-avg').show();
                                _this.setShopDefaultTime(e.params.data.id);
                            });
                            $(_this.$refs.fp_shop).val(data.response.result[1].id).trigger('change');
                            // 区域
                            $(_this.$refs.fp_area).val('').trigger('change');
                            $(_this.$refs.fp_area).prop('disabled', false);
                            _this.getRoomArea($(_this.$refs.fp_shop).val());
                            // 包厢号
                            $(_this.$refs.fp_box).val('').trigger('change');
                            $(_this.$refs.fp_box).prop('disabled', false);
                            _this.getRoomdata($(_this.$refs.fp_shop).val());
                            $('.fp-avg').show();
                            _this.setShopDefaultTime($(_this.$refs.fp_shop).val());
                            _this.getFpList(1);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取包厢区域
            getRoomArea: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getRoomArea",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{id: ' ', text: '全部'}];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.fp_area).html("");
                            $(_this.$refs.fp_area).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: "100%"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取包厢数据
            getRoomdata: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getAllRoom",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let roomDatas = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                roomDatas.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.fp_box).html("");
                            $(_this.$refs.fp_box).select2({
                                data: roomDatas,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },


            getFpList: function(page) {
                let _this = this;
                _this.loading = true

                let ahead_user_name = '',
                    reply_user_name = '',
                    work_number = '';
                if(_this.fp_field == 'ahead_user_name') {
                    ahead_user_name = _this.fp_con_val;
                } else if(_this.fp_field == 'reply_user_name') {
                    reply_user_name = _this.fp_con_val;
                } else if(_this.fp_field == 'work_number') {
                    work_number = _this.fp_con_val;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": page,
                            "page_size": _this.page_size,
                            "start_time": _this.fpStartTime,
                            "end_time": _this.fpEndTime,
                            "shop_id": $(_this.$refs.fp_shop).val(),
                            "room_area": $.trim($(_this.$refs.fp_area).val()),
                            "room_id": $.trim($(_this.$refs.fp_box).val()),
                            "status": $.trim($(_this.$refs.fp_deal).val()),
                            "comment": $.trim($(_this.$refs.fp_evalt).val()),
                            "ahead_user_name": ahead_user_name,
                            "reply_user_name": reply_user_name,
                            "work_number": work_number
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + 'FinanceReport2/getUsersCommentList',
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.total_info = data.response.result.total_info
                            if(page == 1) {
                                _this.list_total = Number(data.response.result.total)
                            }
                            _this.column_arr = []
                            _this.fpExport_checkData = []
                            for(let [key, value] of Object.entries(data.response.result.column_arr)) {
                                _this.column_arr.push({key: key, name: value});
                                _this.fpExport_checkData.push(key)
                            }
                            _this.list_table = data.response.result.rows;
                            _this.loading = false;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getFpExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport2/userCommentsExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.fpExport_checkModel = data.response.result.export_fields;
                                _this.fpExport_type = data.response.result.export_type;
                            } else {
                                _this.fpExport_checkModel = _this.fpExport_checkData;
                                _this.fpExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.fpExport_alert)
                }, function() {
                    _this.exportFpList();
                });
            },
            // 导出字段全选
            fpExportCheckedAll: function(type) {
                let _this = this;
                _this.fpExport_allcheck = _this.c_fpExport_allcheck;
                if(!_this.fpExport_allcheck) { // 实现全选
                    _this.fpExport_checkModel = [];
                    _this.fpExport_checkData.forEach(function(item) {
                        _this.fpExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.fpExport_checkModel = [];
                }
            },
            // 点击“导出”按钮
            exportFpList: function() {
                let _this = this;

                let export_fields = JSON.stringify(_this.fpExport_checkModel);
                let ahead_user_name = '',
                    reply_user_name = '',
                    work_number = '';
                if(_this.fp_field == 'ahead_user_name') {
                    ahead_user_name = _this.fp_con_val;
                } else if(_this.fp_field == 'reply_user_name') {
                    reply_user_name = _this.fp_con_val;
                } else if(_this.fp_field == 'work_number') {
                    work_number = _this.fp_con_val;
                }
                window.location.href = Vue.ctUrl + "FinanceReport2/userCommentsExport" +
                    "?start_time=" + _this.fpStartTime +
                    "&end_time=" + _this.fpEndTime +
                    "&shop_id=" + $(_this.$refs.fp_shop).val() +
                    "&room_area=" + $.trim($(_this.$refs.fp_area).val()) +
                    "&room_id=" + $.trim($(_this.$refs.fp_box).val()) +
                    "&status=" + $.trim($(_this.$refs.fp_deal).val()) +
                    "&comment=" + $.trim($(_this.$refs.fp_evalt).val()) +
                    "&ahead_user_name=" + ahead_user_name +
                    "&reply_user_name=" + reply_user_name +
                    "&work_number=" + work_number +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.fpExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    .fp-list {
        .total-info {
            margin: 20px 0;
            display: flex;
            flex-direction: row;
            align-items: center;
            .item {
                margin-right: 20px;
            }
        }
        .fp-tit-sel {
            width: 125px;
            padding: 0;
        }
        .fixed-table-body {
            overflow-x: scroll;
            table {
                width: 1300px;
                // table-layout: fixed;
                word-break: break-all;
            }
        }
        .fixed-table-body::-webkit-scrollbar {
            position: absolute;
            top: 0;
            left: 0;
            height: 30px;
        }
    }
</style>